import { ScrollArea } from '@/components/atoms/ScrollArea'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/atoms/Table'
import { LabeledInputField } from '@/components/molecules'
import { cn } from '@/utils/cn'
import { useMemo, useState } from 'react'

interface CustomerListProps {
  customers: { name: string; uuid: string }[]
  selectedCustomer: { uuid: string }
  setSelectedCustomer: (customer: { uuid: string }) => void
}

export function CustomerList({ customers, selectedCustomer, setSelectedCustomer }: CustomerListProps) {
  const [filter, setFilter] = useState('')

  const filteredCustomers = useMemo(
    () =>
      customers.filter(({ name, uuid }) => {
        const searchTerm = filter.toLowerCase()
        return name.toLowerCase().includes(searchTerm) || uuid.toLowerCase().includes(searchTerm)
      }),
    [customers, filter]
  )

  return (
    <div>
      <LabeledInputField
        label="Search"
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        placeholder="Search by name or uuid"
        className="mb-4"
      />
      <ScrollArea className="h-100 rounded-2xl md:h-[624px]">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="px-2">
                <p>Customer</p>
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredCustomers.map(({ name, uuid }) => (
              <TableRow
                key={uuid}
                className={cn(uuid === selectedCustomer.uuid && 'bg-blue-500/10')}
                onClick={() => setSelectedCustomer({ uuid })}
              >
                <TableCell className="px-2">
                  <div className="grid grid-cols-[700px_500px] items-center gap-2" data-role="protocol-info">
                    <span className="max-w-full overflow-hidden text-ellipsis whitespace-nowrap" title="name">
                      {name}
                    </span>
                    <span className="max-w-full overflow-hidden text-ellipsis whitespace-nowrap" title="uuid">
                      {uuid}
                    </span>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ScrollArea>
    </div>
  )
}
